// https://eu.posthog.com/project/281/feature_flags?tab=overview
export const FeatureFlags = {
  Eurovision: 'eurovision',
  RemoteMicConnectionType: 'remote_mics_connection_type',
  InitialInputLag: 'initial_input_lag',
  FewerSongsPerRow: 'fewer_songs_per_row',
  NewVolume: 'new_volume',
} as const;
